export default __webpack_public_path__ + "static/media/01AW2JUL66.fe08af67.jpg";